// Svelte 5 issue store with reactive state and utility functions

// Create reactive state for issues
let issues = $state([]);

// Export reactive state getter
export const issueState = {
    get value() {
        return issues;
    }
};

// Export utility functions for managing issues
export function addIssue(newIssue) {
    issues.push(newIssue);
}

export function updateIssue(issueId, updatedData) {
    issues = issues.map(issue => 
        issue.id === issueId ? { ...issue, ...updatedData } : issue
    );
}

export function removeIssue(issueId) {
    issues = issues.filter(issue => issue.id !== issueId);
}

export function setIssues(newIssues) {
    resetIssueState();
    newIssues.forEach(issue =>{
        issues.push({...issue});
    });
}

export function getIssueById(issueId) {
    return issues.find(issue => issue.id === issueId);
}

export function getIssuesByStatus(status) {
    return issues.filter(issue => issue.status === status);
}

export function getIssuesByEventGroup(eventGroupId) {
    return issues.filter(issue => issue.eventGroupId === eventGroupId);
}

export function resetIssueState() {
    // Clear the array by setting its length to 0
    issues.length = 0;
}